import { useConnectivity } from "@/contexts/ConnectivityContext";
import { useSyncStatus } from "@/hooks/useSyncStatus";
import { motion, AnimatePresence } from "framer-motion";
import { WifiOff, RefreshCw, Cloud } from "@/lib/icons";

export function OfflineBanner() {
  const { isOnline, isReconnecting } = useConnectivity();
  const { pendingCount } = useSyncStatus();

  const showBanner = !isOnline || isReconnecting;

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="overflow-hidden"
        >
          <div className={`flex items-center justify-center gap-2 px-4 py-2 text-xs font-medium ${
            isReconnecting
              ? "bg-blue-500/10 text-blue-600 dark:text-blue-400"
              : "bg-amber-500/10 text-amber-700 dark:text-amber-400"
          }`}>
            {isReconnecting ? (
              <>
                <RefreshCw className="h-3.5 w-3.5 animate-spin" />
                <span>
                  Reconnecting{pendingCount > 0 ? ` · Syncing ${pendingCount} change${pendingCount !== 1 ? "s" : ""}…` : "…"}
                </span>
              </>
            ) : (
              <>
                <WifiOff className="h-3.5 w-3.5" />
                <span>
                  You're offline — changes saved locally
                  {pendingCount > 0 && ` (${pendingCount} pending)`}
                </span>
              </>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
